<template>
    <div>
        <b-overlay :show="loaded" rounded="sm">
        <b-row>
                <div class="mt-5 d-inline-block col-6">
                    <h3 class="mobile-font">{{$translate('documents')}}</h3>
                </div>
               
        </b-row>
        <b-modal v-model="isModalVisible" id="message-modal" hide-footer :close-on-backdrop="false" class="pt-8" centered
            header-class="p-0" footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
            <template #modal-title>
                <div class="title-block text-center p-2 m-0">
                    {{ model.id ? $translate('master_document') : $translate('master_document') }}
                </div>
            </template>
            <b-col cols="12" class="mt-3">
               
                <label class="mb-3"><strong>{{ $translate('master_document') }}</strong></label>
                  <b-form-select
                    id="input-master-document-name"
                    v-model="model.master_document_id"
                    :options="master_document"
                    disabled
                  ></b-form-select> 
                </b-col>
                <b-col cols="12" class="mt-3">
                    <label class="mb-3"><strong>{{ $translate('sequence_number') }}</strong></label>
                    <b-form-input type="number" min="1" id="input-sequence-number" v-custom-validation="$textRequired()" v-model="model.sequence_no"
                         :placeholder="$translate('enter_sequence_number')" disabled></b-form-input>
                </b-col>
                    
                <!-- <b-row class="mt-3">
                    <b-col cols="12" class="mb-3">
                        <label><strong>{{ $translate('shared_drive') }}</strong></label>
                    </b-col>
                    <b-col cols="auto" class="mb-3">
                        <b-form-radio
                            v-model="model.shared_drive"
                            name="shared_drive"
                            value="yes"
                            class="mx-1"
                            disabled
                        >&nbsp;{{$translate('yes')}}</b-form-radio>
                    </b-col>
                    <b-col cols="auto" class="mb-3">
                        <b-form-radio
                            v-model="model.shared_drive"
                            name="shared_drive"
                            value="no"
                            class="mr-2"
                            disabled
                        >&nbsp;{{$translate('no')}}</b-form-radio>
                    </b-col>
                </b-row> -->
                    
            
            <b-col cols="12" class="mt-3">
                <label class="mb-3"><strong>{{ $translate('notes') }}</strong>
                </label>
                <b-form-textarea id="input-instructions" disabled v-model="model.notes"
                    :placeholder="$translate('enter_instructions')" rows="3"></b-form-textarea>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label class="mb-3"><strong>{{ $translate('Links') }}</strong>
                </label><br>
                <span v-if="model?.master_document?.link !== ''">
                    <a :href="model?.master_document?.link" class="test-master-document-link" :id="'master-document-id-'+model?.master_document?.id" target="_blank">{{ model?.master_document?.link
                    }}</a>
                </span>
               
            </b-col>
            <b-col cols="12" class="mt-3" v-for="(attachment, index) in model?.master_document?.attachments" :key="index">
                <span v-if="attachment !== ''">
                    <label class="mb-3"><strong>{{ $translate('documents') }}</strong>
                    </label><br>
                    <b-img v-if="['jpg', 'jpeg', 'png'].includes(attachment.file_extension)" :src="attachment.url" fluid alt="Responsive image"></b-img>
                    <a :id="'master-xls-file-'+index" v-else-if="['xls', 'xlsx'].includes(attachment.file_extension)" :href="attachment.url"  @click="downloadFile($event, attachment)">
                        <div class="btn btn-success btn-sm">
                            <i v-b-tooltip.hover :title="$translate('click_to_download')" class="fa-solid fa-file-excel fa-2x"></i>
                        </div>
                    </a>
                    <a :id="'master-pdf-file-'+index" v-else-if="attachment.file_extension === 'pdf'" :href="attachment.url" @click="downloadFile($event, attachment)">
                        <div class="btn delete-button btn-sm">
                            <i v-b-tooltip.hover :title="$translate('click_to_download')" class="fa fa-file-pdf fa-2x"></i>
                        </div>
                    </a>
                      <!-- Display Word file download button -->
                    <a :id="'master-doc-file-'+index" v-else-if="['doc', 'docx'].includes(attachment.file_extension)" :href="attachment.url" @click="downloadFile($event, attachment)">
                        <div class="btn btn-primary btn-sm">
                            <i v-b-tooltip.hover :title="$translate('click_to_download')" class="fa-solid fa-file-word fa-2x"></i>
                        </div>
                    </a>

                    <!-- Display Text file download button -->
                    <a :id="'master-txt-file-'+index" v-else-if="attachment.file_extension === 'txt'" :href="attachment.url" @click="downloadFile($event, attachment)">
                        <div class="btn btn-secondary btn-sm">
                            <i v-b-tooltip.hover :title="$translate('click_to_download')" class="fa-solid fa-file-lines fa-2x"></i>
                        </div>
                    </a>
                </span>
            </b-col>
            
           
            <div class="d-flex justify-content-center mt-3">
                <!-- <b-button  size="sm" @click="createDocument" class="btn-fw me-3" 
                     variant="info">{{ model.id
                        ? $translate('update_master_document') : $translate('add_master_document') }}</b-button> -->
                <b-button size="sm" id="close-master-model" @click="isModalVisible = false" variant="info" class="btn-fw">{{ $translate('close')
                }}</b-button>
            </div>
        </b-modal>
        
      
        <b-row>
            <b-col md="12"  class="mobile-table">
                <b-table id="orderTable" :items="documents" :fields="fields" 
                :busy="tableLoading" responsive 
                    ref="selectableTable"  >
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <!-- <strong>{{ $translate('loading') }}</strong> -->
                        </div>
                    </template>
        
                    <template #empty>
                        <p class="text-center m-0">{{ $translate("add_message_note") }}</p>
                    </template>
                    <template #emptyfiltered>
                        <p class="text-center m-0">{{ $translate("add_message_note") }}</p>
                    </template>
        
                    <template #cell(actions)="{ item }">
                        <div class="d-flex">
                            <b-button  @click="viewItem(item)" class="me-2" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg">
                            </b-button>
                          
                        </div>
                    </template>
        
                    <template #cell(id)="{ index }">
                        <p>
                            {{ index + 1 }}
                        </p>
                    </template>
                    <template #cell(botton)="{ item }">
                     
                        <b-button @click="downloadPdf(item)" :id="'attch_to_activity_'+item.id" v-if="item?.master_document?.link !== ''" class="mt-2 test-attach_to_activity" :disabled=" (viewMode && !isNew)">
                           {{ $translate('attch_to_activity') }}
                          </b-button>
                    </template>
                  
                </b-table>
            </b-col>
        </b-row>
     
      
        </b-overlay>
    </div>
</template>

<script>
// import moment from 'moment'
import popupMixins from '@/mixins/popupMixins';
import permissionsMixins from '@/mixins/permissionsMixins';
import utilityMixins from "@/mixins/utilityMixins";
import locationMixins from '@/mixins/locationMixins'



export default {
    name: 'asset-schedule',
    components: {
        
    },  
    mixins: [popupMixins, permissionsMixins, utilityMixins,locationMixins],
    data() {
        return {
            model: {},
            isModalVisible: false,
            scheduleCreated: false,
            tableLoading: true,
            submitting: false,
            itemsPerPage: 15,
            currentPage: 1,
            loaded:true,
          
        }
    },
    props: [
        'viewMode',
        'isNew',
        'activityTypeId',
        'refNo',
        

    ],
    filters: {
        // displayTime(date) {
        //     const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        //     console.log('timezone', timezone)
        //     if (date) {
        //         return new Date(date).toLocaleString('en-US', {
        //             timeZone: timezone,
        //         })
        //     } else {
        //         return ''
        //     }
        // },
    },
    async created(){
        await  this.$store.dispatch('orderType/master_docs');
    },
    computed: {
        componentName() {   
       
                return this.$translate('activity');
           
        },
        fields() {


            return [
              
                {
                    key: 'actions',
                    label: this.$translate('actions'),
                    class: 'actionButton_class',
                },
               

                {
                    key: 'sequence_no',
                    label: this.$translate('sequence_no'),
                    
                },
                {
                    key: 'master_document',
                    label: this.$translate('master_document'),
                    formatter: (value) => value?.name,
                   
                },
                // {
                //     key: 'shared_drive',
                //     label: this.$translate('shared_drive'),
                   
                // },
                {
                    key: 'notes',
                    label: this.$translate('notes'),
                   
                },
                {
                    key: 'botton',
                    label: this.$translate('attach'),
                   
                }
              
                
            ]
        },
        master_document() {
            return this.$store.state.orderType.master_docs.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },

        documents() {
            console.log('data----------', this.$store.state.acitivityTypeDocStore.docs)
            return this.$store.state.acitivityTypeDocStore.docs
        },
    
        // pageCount() {
        //     return Math.ceil(this.pagination.total / this.pagination.pageSize);
        // },
        // pagination() {
        //     return this.$store.state.acitivityTypeDocStore.pagination || { page: 1 };
        // },
        mediaBaseUrl() {
            return this.$store.getters['mediaBaseUrl']
        },
       
    },
    watch: {
        // 'assetSchedules': {
        //     handler: function (schedules) {
        //         this.$store.dispatch('assetScheduleStore/load', schedules)
        //     },
        //     deep: true,
        // },
       
       "pagination.page": function (val) {
            console.log('page-----',val)
            this.doSearch();
        },
    },
    async mounted() {
        // const { notes } = this.order
        // const schedule_data = this.assetSchedules
        // this.scheduleCreated = false
        // this.$store.dispatch('assetScheduleStore/load', schedule_data || [])
        // this.doSearch();
        this.loaded = false;
        this.tableLoading = false;
    },
    methods: {
      
        getLabel(value) {
            const label =
                value == "task_title"
                ? this.crm
                    ? this.$translate("task_title")
                    : this.$translate("name")
                : this.$translate(value);
            return label;
        },
        viewItem(item) {
            this.model = { ...item }
           
            this.isModalVisible = true
        },

    async downloadPdf(model) {
      var  label = '';
       this.loaded = true;
      const link = model?.master_document?.link;
      console.log('this is callleeeddd',link);
       if (link) {
        try {
          const response =   await this.$store.dispatch('acitivityTypeDocStore/convertToPdf', {
                link: link,
            });
          
            const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
            // console.log('response is -----',blob);
            // console.log('response is -----',await blob.text());

            // const url = window.URL.createObjectURL(blob);
            // const new_link = document.createElement("a");
            // new_link.href = url;
            // new_link.setAttribute("download",  "Sample.pdf");
            // document.body.appendChild(new_link);
            // new_link.click();
            // document.body.removeChild(new_link);
            // window.URL.revokeObjectURL(url);


//           const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

         // Create a File object from the Blob
          let name = model?.master_document?.name+'-'+this.refNo.reference_no+'.pdf';
          
          const file = new File([pdfBlob], name, { type: 'application/pdf' });
          const files = [file];

          const p = await this.getCurrentLocation()
                console.log('coordinates', p)
                const lat = p.coords.latitude
                const long = p.coords.longitude
          let { keys } = await this.$store.dispatch(
                    's3files/s3upload',
                    files
                )
                let url = [];
                keys.forEach(key => {
                    url.push(`${this.mediaBaseUrl}/${key}`);
                });

                const newFiles = files.map((element, i) => ({
                    name: element.name.replace(/\.[^/.]+$/, ''),
                    url: url[i],
                    file_extension: element.name.split('.').pop(),
                    lat: lat,
                    long: long,
                }));

               

               await this.$store.dispatch('orderAttachmentsStore/merge', {
                    newFiles,
                })
                this.genericToast(
            this.componentName,
            label,
            'success',
            `${this.componentName} ${this.$translate('attach_master_doc')}`
        );
                this.loaded = false;
          } catch (error) {
          console.error('Error downloading PDF:', error);
        }
      }
    },

    async createDocument() {
    let isError = false; 
    try {
        // const { model } = this;
        let label = "";

       
        // if (!model.name || !model.frequency || !model.order_template_id || !model.next_service_date) {
        //     throw new Error(this.$translate("schedule_error"));
        // }

        if (this.model.id) {
            label = this.$translate('updated');
            await this.$store.dispatch('acitivityTypeDocStore/updateDocument', {
                schedule: this.model,
                activityTypeId: this.activityTypeId
            });
        } else {
            label = this.$translate('created');
            await this.$store.dispatch('acitivityTypeDocStore/addDocument', {
                schedule: this.model,
                activityTypeId: this.activityTypeId
            });
        }

       
       

        this.scheduleCreated = true;

        let type_id = null
        if(this.crm){
            type_id = this.crmSettingValue.type_id;
        }
        await this.$store.dispatch('acitivityTypeDocStore/fetchdocuments', {  activityTypeId : this.activityTypeId,type_id});
       

        
        await this.doSearch();
        this.genericToast(
            this.componentName,
            label,
            'success',
            `${this.componentName} ${this.$translate('save_alert')}`
        );

      
    } catch (err) {
       
        this.doToast(
            this.$translate("error"),
            err.message,
            "danger"
        );
        isError = true; 
    } finally {
       
        if (!isError) {
            this.isModalVisible = false;
        }
    }
},


        async doSearch() {
          
            let {
                
                pagination: { page },
                
            } = this
          
          
            page = parseInt(page) || 1;

            // this.tableLoading = true
            // this.loaded = true;
            try{
                let type_id = null
                if(this.crm){
                    type_id = this.crmSettingValue?.type_id;
                }
              
                await this.$store.dispatch('acitivityTypeDocStore/fetchdocuments', {
                    activityTypeId : this.activityTypeId,
                    page ,
                    type_id
                })
            } catch(err) {
                console.log('fetch Error: ', err);
                this.doToast(this.$translate('error'), err.message, 'danger')
            } finally {
                this.tableLoading = false;
                this.loaded = false;
            }
        },
        // deleteMessage(hash) {
        //     this.$store.dispatch('assetScheduleStore/delete', hash)
        //     this.genericToast(
        //         this.componentName,
        //         this.$translate('deleted'),
        //         'success',
        //         `${this.componentName} ${this.$translate('delete_alert')}`
        //     )
        //     this.$emit('success', this.componentName, this.$translate('deleted'))
        // },

        async deleteSchedule(scheduleId) {
            const confirmed = confirm('Are you sure you want to delete this schedule?');

            // Proceed only if the user confirms
            if (confirmed) {
                // const { model } = this;
                await this.$store.dispatch('acitivityTypeDocStore/deleteAssetSchedule', {
                    schedule: scheduleId,
                    activityTypeId: this.activityTypeId
                });
                // Fetch the updated list of asset schedules
                await this.doSearch();
                this.genericToast(
                this.componentName,
                this.$translate('deleted'),
                'success',
                `${this.componentName} ${this.$translate('delete_alert')}`
            )
            }
        },
        downloadFile(event, attachment) {
        event.preventDefault();
        fetch(attachment.url)
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = attachment.name;  // This sets the name of the downloaded file
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch(error => console.error('Download error:', error));
    }

       
    },
}
</script>

<style>
.text-wrap {
    white-space: normal !important;
}

.created_at_class,
.user_id_class {
    width: 20% !important;
}

.id_class {
    width: 2% !important;
}

.actionButton_class {
    width: 8% !important;
}
</style>
